const productColumns = document.querySelectorAll(".mega-menu__list .product--column");


productColumns.forEach((el, index) => {
    const parent = el.parentElement;
    el.addEventListener("mouseenter", () => {
        parent.classList.add("hovering");
    });
    el.addEventListener("mouseleave", () => {
        parent.classList.remove("hovering");
    });
    parent.addEventListener("mouseenter", () => {
        el.classList.add("active");
    })
    parent.addEventListener("mouseleave", () => {
        el.classList.remove("active");
    });
    window.addEventListener("load", () => {
         if (index === 0) {
            parent.classList.add("hovering");
            el.classList.add("active");
        }
    });
});

function highlightFirstOnClose() {
    productColumns.forEach((el, index) => {
    const parent = el.parentElement;
        if (index === 0) {
            parent.classList.add("hovering");
            el.classList.add("active");
        }
});
}

const megaMenuItems = document.querySelectorAll(".mega-menu");
let currentItemIndex;

  megaMenuItems.forEach((item, itemIndex) => {
    const content = item.querySelector(".mega-menu__content")
    item.addEventListener("mouseover", () => {
      if (
        (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
        (currentItemIndex && currentItemIndex !== itemIndex)
      ) {
        megaMenuItems[currentItemIndex].removeAttribute("open")
      }

      currentItemIndex = itemIndex
      item.setAttribute("open", true)
    })

    item.addEventListener("mouseleave", (event) => {
      let close = true

        const closeTimeout = setTimeout(() => {
            if (close) item.removeAttribute("open");
            highlightFirstOnClose();
        }, 200);

      content.addEventListener("mouseover", () => {
        close = false
      })

      item.addEventListener("mouseover", () => {
        clearTimeout(closeTimeout)
      })
    })

    content.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        highlightFirstOnClose();
    })
  })